<form (ngSubmit)="toggleSelected()" [formGroup]="form" fxLayout="column">
  <header>
    {{ format.name }}
    <mat-icon @appear *ngIf="selected" class="rds-c-selected-icon">check_circle</mat-icon>
  </header>
  <section fxFlex="noshrink" fxLayout="row wrap" fxLayoutAlign="start start">
    <p class="mat-body-1" fxFlex="100">{{ format.description }}</p>
    <ng-container
      *ngFor="let option of optionSet.options; trackBy: _trackByOption; let even = even; let last = last"
      [ngSwitch]="option.dataType"
    >
      <!-- Use checkbox for boolean options -->
      <mat-checkbox
        *ngSwitchCase="'BOOLEAN'"
        [class.space-right]="even && !last"
        [formControlName]="option.id"
        fxFlex="calc(50% - 16px)"
        fxFlexAlign="center"
        fxLayout="row"
        fxLayoutAlign="start center"
        [required]="option.required"
        >{{ option.name || option.id }}
        <mat-icon
          aria-hidden="false"
          class="popover-button"
          [mtnaPopover]="option | rdsOptionPopoverConfig"
          [mtnaClosePopoverAriaLabel]="option.name | rdsPopoverAriaLabel: false"
          [mtnaOpenPopoverAriaLabel]="option.name | rdsPopoverAriaLabel: true"
          >info</mat-icon
        >
      </mat-checkbox>
      <!-- Defaults to text input -->
      <mat-form-field
        *ngSwitchDefault
        appearance="outline"
        [class.space-right]="even && !last"
        floatLabel="always"
        fxFlex="calc(50% - 16px)"
      >
        <mat-label>{{ option.name || option.id }}</mat-label>
        <input matInput [formControlName]="option.id" placeholder="Enter a value" [required]="option.required" />
        <mat-error> {{ option.name || option.id }} is <strong>required</strong> </mat-error>
        <mat-icon
          aria-hidden="false"
          class="popover-button"
          [class.disabled]="selected"
          [mtnaPopover]="option | rdsOptionPopoverConfig"
          [mtnaClosePopoverAriaLabel]="option.name | rdsPopoverAriaLabel: false"
          [mtnaOpenPopoverAriaLabel]="option.name | rdsPopoverAriaLabel: true"
          >info</mat-icon
        >
      </mat-form-field>
    </ng-container>
  </section>
  <footer fxLayout="row" fxLayoutAlign="end center">
    <button [color]="color" mat-button type="submit">{{ selected ? 'DESELECT' : 'SELECT' }}</button>
  </footer>
</form>
